export const data = [
  {
    id: 1,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAD-cafe-project%2FIMG-20231229-WA0083.webp?alt=media&token=2eecd7d7-f5cf-495a-a1a3-d31810006904",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAD-cafe-project%2FIMG-20231229-WA0083.webp?alt=media&token=2eecd7d7-f5cf-495a-a1a3-d31810006904",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAD-cafe-project%2FIMG-20231229-WA0083.webp?alt=media&token=2eecd7d7-f5cf-495a-a1a3-d31810006904",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAD-cafe-project%2FIMG-20231229-WA0132.webp?alt=media&token=cbd311b5-74fd-4e16-84b1-8726842d1db7",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAD-cafe-project%2FIMG-20231229-WA0133.webp?alt=media&token=1874cdc9-d647-4b15-ae93-d4f38d0ef90e",
    youtube: "",
    title: "AD Cafe",
    cardtext:
      "Opened in January 2022 a beautiful spot, unique blend of modern to take and peaceful environment have a selfie spots to capture the vibrancy of atmosphere. The wall is decorated with captivating artworks portraying city scenes and moonlight. Cafe stands an peaceful retreat offering a visually fascinating and stimulating environment.",
    info: (
      <div>
        Opened in January 2022 a beautiful spot, unique blend of modern to take
        and peaceful environment have a selfie spots to capture the vibrancy of
        atmosphere. The wall is decorated with captivating artworks portraying
        city scenes and moonlight. Cafe stands an peaceful retreat offering a
        visually fascinating and stimulating environment.
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 2,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAdwait-project2.0%2FIMG-20231229-WA0100.webp?alt=media&token=f26ada64-160f-4728-91f9-f99c3565e360",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAdwait-project2.0%2FIMG-20231229-WA0088.webp?alt=media&token=262eaa11-84ee-42e3-97ed-8155c21e3de3",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAdwait-project2.0%2FIMG-20231229-WA0091.webp?alt=media&token=c6921fd3-c5de-4279-8c72-1122bff5275c",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAdwait-project2.0%2FIMG-20231229-WA0093.webp?alt=media&token=7633ffa8-60c4-4a9d-a6b2-909a27d9874d",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAdwait-project2.0%2FIMG-20231229-WA0101.webp?alt=media&token=56633e5c-6a85-48f0-8479-9659d5305e16",
    youtube: "",
    title: "Adwait 2.0",
    cardtext:
      "Serve as the basis of centre of artistic performance, beautiful artwork performed in Haridwar depicting drawings of Krishna and Balram feet on the banks of Birla Ghat performed between feb to April 2021.",
    info: (
      <div>
        <p>
          Serve as the basis of centre of artistic performance, beautiful
          artwork performed in Haridwar depicting drawings of Krishna and Balram
          feet on the banks of Birla Ghat performed between feb to April 2021.
        </p>
        <br />
        <p>The creative effort was done depicting Surya Dev and Asthpath.</p>
        <br />
        <p>
          Adding to the charm and elephant depicting butterfly at Birla Ghat
          providing unconventional touch complemented by a selfie point.
        </p>
        <br />
        <p>
          At the boundary walls of the Jal Sansthan are the way Adwait 2.0
          performed work at showcasing A portrait of Bhagat Singh and blending
          art with culture and historical significance.
        </p>
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 3,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBharatRam-project%2FUntitled%20design%20(5)%20(1).webp?alt=media&token=45c54841-8854-498c-8bc6-5ccee71b22e6",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBharatRam-project%2FIMG20230218191056.webp?alt=media&token=75cbb3b3-b5a0-4182-94bd-ba15789d58ae",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBharatRam-project%2FIMG20230218191107.webp?alt=media&token=1f883b67-1ee9-4d4a-8b27-ae38584c9cbc",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBharatRam-project%2FIMG_20230219_201900.webp?alt=media&token=d5c394c4-4ba9-4438-8603-4df5d8489324",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBharatRam-project%2FIMG_20230219_201916.webp?alt=media&token=4f3903a2-2116-4025-a37a-392c018a230f",
    youtube: "",
    title: "BharatRam Global School",
    cardtext:
      "It Became a beautiful place of creativity and art form representing various art forms performed in music and dance room .Art room was transford into creative environment where students can showcase their innovative thoughts. Play room was playful and a visually delight retreat for students which enrich the educational experience.",
    info: (
      <div>
        <p>
          It became a beautiful place of creativity and art form representing
          various art forms performed in music and dance room .Art room was
          transformed into creative environment where students can showcase
          their innovative thoughts.
        </p>{" "}
        <br />{" "}
        <p>
          Play room was playful and a visually delight retreat for students
          which enrich the educational experience.
        </p>
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 4,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBrahmaKumaris-project%2FIMG-20231229-WA0128.webp?alt=media&token=8087927d-593b-47e7-a2dd-568adcdd0f72",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBrahmaKumaris-project%2FIMG-20231229-WA0097.webp?alt=media&token=49d5aa22-7812-470d-a658-d3d173a669c8",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBrahmaKumaris-project%2FIMG-20231229-WA0098.webp?alt=media&token=525bb61d-dca3-41d0-8c54-8497c96b183d",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBrahmaKumaris-project%2FIMG-20231229-WA0104.webp?alt=media&token=54ec83bc-bc04-422d-ad1c-bf4d8510237a",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBrahmaKumaris-project%2FIMG-20231229-WA0102.webp?alt=media&token=83e575bb-5bee-4684-864b-8b3b93d7e513",
    youtube: "",
    title: "Brahma Kumari",
    cardtext:
      "Initiated in September 2021, bloomed into peaceful, calm fear for women's meditation in kurukshetra Haryana providing space for spiritual growth and inner reflection. It also has culture paintings in the environment and contributing to harmony.",
    info: (
      <div>
        Initiated in September 2021, bloomed into peaceful, calm atmosphere for
        women&#39;s meditation in kurukshetra Haryana providing space for
        spiritual growth and inner reflection. It also has culture paintings in
        the environment and contributing to harmony.
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 5,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FMartiniCafe-project%2FIMG_20230423_224504.webp?alt=media&token=42dd5a36-5a1f-4d4c-8b47-cab08b2804af",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FMartiniCafe-project%2FIMG20230422142609.webp?alt=media&token=81c48d6f-96ab-4658-9d7d-21722fdb196a",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FMartiniCafe-project%2FIMG_20230422_210520.webp?alt=media&token=d86ff0e9-551c-4059-808b-4af6c6bec7e1",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FMartiniCafe-project%2FIMG_20230422_210832.webp?alt=media&token=a665e18f-7080-4ba5-9cde-add441fe0963",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FMartiniCafe-project%2FIMG_20230422_210723.webp?alt=media&token=e0c765bb-1c08-487f-a5d5-c2303a8e1bff",
    youtube: "",
    title: "Martini Cafe",
    cardtext:
      "Atmosphere of the cafe was elevated by performing modern arts would showcased elegance. Spot is also dedicated here as a selfie point enhancing the visual pleasures and experience of customers. This artwork was performed during the year 2023.",
    info: (
      <div>
        Atmosphere of the cafe was elevated by performing modern arts would
        showcased elegance. Spot is also dedicated here as a selfie point
        enhancing the visual pleasures and experience of customers. This artwork
        was performed during the year 2023.
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 6,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fadwait-project%2FIMG-20231229-WA0112.webp?alt=media&token=e852a113-a1e3-4e81-a36d-2a0074e19791",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fadwait-project%2FIMG-20231229-WA0114.webp?alt=media&token=46096cd8-751a-48bf-91c9-dcefa05c2b88",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fadwait-project%2FIMG-20231229-WA0125.webp?alt=media&token=54bf2afb-05d7-45dd-af1e-79e0e67b9fd0",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fadwait-project%2FIMG-20231229-WA0124.webp?alt=media&token=6255a0d4-66ad-4e7b-8359-fecf411f73fb",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fadwait-project%2FIMG-20231229-WA0118.webp?alt=media&token=85a27a74-9d5b-4f2e-ae79-f4b9628dcd7d",
    youtube: "",
    title: "Adwait",
    cardtext:
      "Advait established in December 2018, in Allahabad serving as a mediator which connects art forms representing beautiful meanings. Here, MahaKumbh wall art was adopted the art form that was used was Patchitra, which left a artistic mark on Naini railway station.",
    info: (
      <div>
        <p>
          Adwaiit established in December 2018, in Allahabad serving as a
          mediator which connects art forms representing beautiful meanings.
          Here, MahaKumbh wall art was adopted the art form that was used was
          Patchitra, which left a artistic mark on Naini railway station.
        </p>
        <br />
        <p>
          Other work like Nagwaski temple situated beside the river in Allahabad
          was enhanced with adorning the pillar beauty works. Making a visually
          fascinating environment.
        </p>
        <br />
        <p>
          Represents commitment to infusing various art works into public spaces
          and creating appealing environment.
        </p>
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 7,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fakbarigate-project%2FakabariGatePic.webp?alt=media&token=6d569b4f-1e59-4c4b-ad23-88000552ccb6",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fakbarigate-project%2FIMG_20230816_173023157.webp?alt=media&token=3330f4b3-3300-4746-b431-387ba5121ea1",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fakbarigate-project%2FIMG_20230816_173144550_HDR.webp?alt=media&token=ff952aac-53e9-49af-9a5e-a7c05f8ee147",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fakbarigate-project%2FIMG20230816172649.webp?alt=media&token=a46e4f3e-90ab-45f1-935e-7b6dc2970402",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fakbarigate-project%2FIMG_20230816_174736651.webp?alt=media&token=1e43b13b-08b3-4520-9ff1-fe88e66032ea",
    youtube: "",
    title: "Akbari Gate",
    cardtext:
      "Another demonstration of Glory art form, which is an family restaurant situated in Kamla Nagar Delhi, giving a cultural rich and warm atmosphere providing a delightful experience is to the customers.",
    info: (
      <div>
        <p>
          Another demonstration of Glory art form, which is an family restaurant
          situated in Kamla Nagar Delhi, giving a cultural rich and warm
          atmosphere providing a delightful experience to the customers.
        </p>
        <br />
        <p>
          It consist of interior designs that reflects a fusion of modern art
          with charm of Mughal arts. It&#39;s integrated patterns consist of
          dynamic colours reflecting cultural regioness associated with
          Akbar&#39;s reign. Here work was performed in the year August 2023.
        </p>
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 8,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fallen-project%2FIMG_20230411_064407.webp?alt=media&token=b6278b03-d0f1-4d5e-bc14-d8ed50aa2e7f",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fallen-project%2FIMG_20230409_161957.webp?alt=media&token=91660eeb-65a7-465b-bf3c-a08d246f558e",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fallen-project%2FIMG_20230411_064407.webp?alt=media&token=b6278b03-d0f1-4d5e-bc14-d8ed50aa2e7f",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fallen-project%2FIMG_20230411_101846.webp?alt=media&token=72a793ae-5a72-4d2c-adda-d13cdd85c1fd",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fallen-project%2FIMG_20230417_072748.webp?alt=media&token=68448104-0768-4667-9e0a-3ef5d124ec46",
    youtube: "",
    title: "Allen",
    cardtext:
      "Allen institute which is well known for there academics excellence also indulge in CSR ( Corporate Social Responsibility) initiative- engaging in meaningful community services and impacting the society positively. Here, the walls are adorn with painting that reflects their devotion to education- centric art providing a positive and inspiring environment for students.",
    info: (
      <div>
        <p>
          Allen institute which is well known for there academics excellence
          also indulge in CSR ( Corporate Social Responsibility) initiative-
          engaging in meaningful community services and impacting the society
          positively. Here, the walls are adorn with painting that reflects
          their devotion to education- centric art providing a positive and
          inspiring environment for students.
        </p>
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 9,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FartEffect-project%2FIMG-20220318-WA0069.webp?alt=media&token=a9d6db92-48bb-4b78-b113-2a6076dfc989",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FartEffect-project%2FIMG-20230813-WA0065.webp?alt=media&token=78570db3-736c-4f9d-bf14-9c4e7fd0ab47",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FartEffect-project%2FIMG-20230813-WA0075.webp?alt=media&token=771368de-c4b6-4f6f-8c69-669fcb3f82e3",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FartEffect-project%2FIMG-20231106-WA0064.webp?alt=media&token=d3949c71-aaa5-4221-808a-7c2e73fb77b9",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FartEffect-project%2FIMG-20231106-WA0065.webp?alt=media&token=68b01820-ace1-4356-b205-e0df0bbecd2b",
    youtube: "",
    title: "Art Effect",
    cardtext:
      "Started from 2021 to 2023, consistered of Arts performed at 'Sanjay Van Lake' which witness the beauty of swan and whale arts connecting and reuniting art and nature. Monumental art forms were also performed at the KVS and JNU Headquarters, prominent kal monuments structures like the Red fort and Qutub minar.",
    info: (
      <div>
        <p>
          Started from 2021 to 2023, consistered of Arts performed at 'Sanjay
          Van Lake' which witness the beauty of swan and whale arts connecting
          and reuniting art and nature.
        </p>
        <br />
        <p>
          Monumental art forms were also performed at the KVS and JNU
          Headquarters, prominent monuments structures like the Red fort and
          Qutub minar.
        </p>
        <br />
        <p>
          Sports related theme art forms were performed at DPS Noida
          Headquarters, where various art forms related to sports like chess was
          innovatively showcased.
        </p>
        <br />
        <p>
          Vibrant bird Murals also adorning the parking and sport related art
          forms were also done at Noida Sector 89, celebrated the nature and
          sports collectively making the environment more attractive and
          visually appealing.
        </p>
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 10,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FcosyCafe-project%2FIMG20230205104350.webp?alt=media&token=c3061f17-d334-4319-984f-c7c41563493d",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FcosyCafe-project%2FIMG-20230205-WA0037.webp?alt=media&token=b3595395-bc11-4a19-a0d4-ee3bfc8de585",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FcosyCafe-project%2FIMG_20230205_201533.webp?alt=media&token=f99043b2-7f8d-4751-803e-2e8f2b747adc",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FcosyCafe-project%2FIMG_20230206_183119.webp?alt=media&token=14913079-1923-4a28-817c-bd6d480276a8",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FcosyCafe-project%2FIMG20230205152503.webp?alt=media&token=7dbc5a88-b0e2-42e5-9fae-d0f18a2a73bc",
    youtube: "",
    title: "Cosy Cafe",
    cardtext:
      "Cozy Cafe a place of captivating glide full blend of comfort and creativity. Mural arts form like pop art which enhances the beauty of wall making it vibrant and visually appealing. The lively colours and bold designs bring life to the walls.",
    info: (
      <div>
        <p>
          Cozy Cafe a place of captivating glide full blend of comfort and
          creativity. Mural arts form like pop art which enhances the beauty of
          wall making it vibrant and visually appealing. The lively colours and
          bold designs bring life to the walls.
        </p>
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 11,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fpromocare-project%2FIMG20210122180649.webp?alt=media&token=ac474cd7-f8d1-4252-ad74-db577e9ea0a5",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fpromocare-project%2FIMG_20210128_185034.webp?alt=media&token=49e095fa-ffd1-488d-b1ab-a26673ada897",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fpromocare-project%2FIMG20210320141243.webp?alt=media&token=94c5ccc0-7cb4-4386-8ade-b46f7cadd1fa",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fpromocare-project%2FIMG20210320103224.webp?alt=media&token=996476bc-0483-4069-b901-863418e93682",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fpromocare-project%2FIMG20210327164329.webp?alt=media&token=de58edbf-ac4d-487a-b7f1-5db101c9e3ad",
    youtube: "",
    title: "Promocare",
    cardtext:
      "Sir as a witness for artistic work performed from January to April 2021, beautifying the pillars at New Setu, Janak Setu. Art work contributed to addition of champ to the environment and culture of Allahabad.",
    info: (
      <div>
        <p>
          It stand as a witness for artistic work performed from January to
          April 2021, beautifying the pillars at New Setu, Janak Setu. Art work
          contributed to addition of charm to the environment and culture of
          Allahabad.
        </p>
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 12,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Frenukiran-project%2FIMG_20230923_190800.webp?alt=media&token=b9cc8652-772b-4751-b17c-748e29301bd9",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Frenukiran-project%2FIMG-20231024-WA0076.webp?alt=media&token=4358be30-2cdd-4556-98f4-91b6e318657b",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Frenukiran-project%2FIMG20230824205249.webp?alt=media&token=73237659-34fe-429b-8406-0767bb6f2b8d",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Frenukiran-project%2FIMG_20230923_190800.webp?alt=media&token=b9cc8652-772b-4751-b17c-748e29301bd9",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Frenukiran-project%2FIMG_20231104_142146.webp?alt=media&token=54b971c6-b3c9-4571-864f-c56d4e55e68f",
    youtube: "",
    title: "Renukiran Foundation",
    cardtext:
      "It is an Non-governmental Organisation which operates on non-profit basis, focuses upon collaborative journey started in 2023, still persist to this day performing CSR(Corporate Social cial Responsibility ) activities engaging in education initiative performed across Delhi NCR schools.",
    info: (
      <div>
        <p>
          It is an Non-governmental Organisation which operates on non-profit
          basis, focuses upon collaborative journey started in 2023, still
          persist to this day performing CSR(Corporate Social cial
          Responsibility ) activities engaging in education initiative performed
          across Delhi NCR schools.
        </p>
        <br />
        <p>
          While connecting education and art together giving students a visually
          appealing environment and stimulating their education experiences.
        </p>
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 13,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fsambharya-project%2FIMG_20220228_180720.webp?alt=media&token=8affc3d9-b131-49b0-81f6-b975e7889a86",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fsambharya-project%2FIMG-20220407-WA0004.webp?alt=media&token=8d182e3c-1e67-4342-bf1b-1b9a12769251",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fsambharya-project%2FIMG_20220228_225115.webp?alt=media&token=90cb5997-25d0-42cb-a686-46d64bb170f7",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fsambharya-project%2FIMG-20220407-WA0011.webp?alt=media&token=e1450547-6492-49c5-8574-254433171b58",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fsambharya-project%2FIMG-20220407-WA0015.webp?alt=media&token=7b4cb0bd-34ac-46c8-a2cd-b954b7af7f45",
    youtube: "",
    title: "Sambharya Foundation",
    cardtext:
      "Contracted under government under took between Feburary to April 2022, performed work like adorning the flyover pillars with beautifying and captivating art form of Madhubani. Depicts a touch of rich culture to the public places.",
    info: (
      <div>
        <p>
          Contracted under government under took between Feburary to April 2022,
          performed work like adorning the flyover pillars with beautifying and
          captivating art form of Madhubani. Depicts a touch of rich culture to
          the public places.
        </p>
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 14,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FschoolOfExcellence-project%2FIMG_20180903_193907.webp?alt=media&token=88d20135-e826-4748-8c51-d73d56e63130",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FschoolOfExcellence-project%2FIMG_20180915_200532.webp?alt=media&token=7938517f-5af7-4ab5-82b2-4fbbbe3ece90",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FschoolOfExcellence-project%2FIMG_20181012_124821.webp?alt=media&token=b7dbe6b5-08a1-4c71-b192-f2ae32d00ff2",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FschoolOfExcellence-project%2FIMG_20181012_124821.webp?alt=media&token=b7dbe6b5-08a1-4c71-b192-f2ae32d00ff2",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FschoolOfExcellence-project%2FIMG_20180903_193907.webp?alt=media&token=88d20135-e826-4748-8c51-d73d56e63130",
    youtube: "",
    title: "School of Excellence",
    cardtext:
      "In the year 2018, visionary artist like Vikash Mandal and Mohammed Zaid collaborated together shared a remarkable journey,performing mural arts based on educational theme- depicting and meeting beautiful work arts and signifying the essence of education, connecting knowledge with art. Showing their art works with a meaningful purpose and creating postive impact on individuals and society as a whole.",
    info: (
      <div>
        <p>
          In the year 2018, visionary artist like Vikash Mandal and Mohammed
          Zaid collaborated together shared a remarkable journey,performing
          mural arts based on educational theme- depicting and meeting beautiful
          work arts and signifying the essence of education, connecting
          knowledge with art. Showing their art works with a meaningful purpose
          and creating postive impact on individuals and society as a whole.
        </p>
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 15,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FJDsalwan-project%2FIMG20220330102021.webp?alt=media&token=607b42c3-ff32-45b4-bc9a-c0f39971f491",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FJDsalwan-project%2FIMG-20220401-WA0003.webp?alt=media&token=eb5cf1fc-1b8a-4cce-a254-12766c240467",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FJDsalwan-project%2Fgdsalwan1.webp?alt=media&token=48a5f7ca-a26a-494b-9fe0-cb91302169df",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FJDsalwan-project%2Fgdsalwan2.webp?alt=media&token=ccfe52c1-1bf9-4dea-b686-ba3bc03b8d89",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FJDsalwan-project%2Fgdsalwan3.webp?alt=media&token=30873f67-2dec-473b-9809-2a75a489babf",
    youtube: "",
    title: "GD salwan",
    cardtext: "",
    info: <div></div>,
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
];

export const wallArtData = [
  {
    id: 1,
    title: "Wall Art 01",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260301_122238.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 2,
    title: "Wall Art 02",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260301_122254.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 3,
    title: "Wall Art 03",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260311_144616.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 4,
    title: "Wall Art 04",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260312_144706.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 5,
    title: "Wall Art 05",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260316_120913.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 6,
    title: "Wall Art 06",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260317_155952.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 7,
    title: "Wall Art 07",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260531_104022.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 8,
    title: "Wall Art 08",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260531_104635.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 9,
    title: "Wall Art 09",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_143148.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 10,
    title: "Wall Art 10",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_143356.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 11,
    title: "Wall Art 11",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_143551.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 12,
    title: "Wall Art 12",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_143559.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 13,
    title: "Wall Art 13",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_143612.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 14,
    title: "Wall Art 14",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_143638.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 15,
    title: "Wall Art 15",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_143814.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 16,
    title: "Wall Art 16",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_143820.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l.-708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 17,
    title: "Wall Art 17",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_143828.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 18,
    title: "Wall Art 18",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_144036.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 19,
    title: "Wall Art 19",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_144142.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 20,
    title: "Wall Art 20",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_144227.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 21,
    title: "Wall Art 21",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_144417.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 22,
    title: "Wall Art 22",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_144441.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 23,
    title: "Wall Art 23",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_144444.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 24,
    title: "Wall Art 24",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_144506.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 25,
    title: "Wall Art 25",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_144623.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 26,
    title: "Wall Art 26",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_144732.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 27,
    title: "Wall Art 27",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260606_144934.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
  {
    id: 28,
    title: "Wall Art 28",
    img1: "https://storage.googleapis.com/taba-5c32a.appspot.com/taba_2/20260611_164853.webp",
    img2: "",
    img3: "",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
];

export const movingCarouselData = [
  {
    id: 2,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAdwait-project2.0%2FIMG-20231229-WA0100.webp?alt=media&token=f26ada64-160f-4728-91f9-f99c3565e360",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAdwait-project2.0%2FIMG-20231229-WA0088.webp?alt=media&token=262eaa11-84ee-42e3-97ed-8155c21e3de3",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAdwait-project2.0%2FIMG-20231229-WA0091.webp?alt=media&token=c6921fd3-c5de-4279-8c72-1122bff5275c",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAdwait-project2.0%2FIMG-20231229-WA0093.webp?alt=media&token=7633ffa8-60c4-4a9d-a6b2-909a27d9874d",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FAdwait-project2.0%2FIMG-20231229-WA0101.webp?alt=media&token=56633e5c-6a85-48f0-8479-9659d5305e16",
    youtube: "",
    title: "Adwait 2.0",
    cardtext:
      "Serve as the basis of centre of artistic performance, beautiful artwork performed in Haridwar depicting drawings of Krishna and Balram feet on the banks of Birla Ghat performed between feb to April 2021.",
    info: (
      <div>
        <p>
          Serve as the basis of centre of artistic performance, beautiful
          artwork performed in Haridwar depicting drawings of Krishna and Balram
          feet on the banks of Birla Ghat performed between feb to April 2021.
        </p>
        <br />
        <p>The creative effort was done depicting Surya Dev and Asthpath.</p>
        <br />
        <p>
          Adding to the charm and elephant depicting butterfly at Birla Ghat
          providing unconventional touch complemented by a selfie point.
        </p>
        <br />
        <p>
          At the boundary walls of the Jal Sansthan are the way Adwait 2.0
          performed work at showcasing A portrait of Bhagat Singh and blending
          art with culture and historical significance.
        </p>
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 3,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBharatRam-project%2FUntitled%20design%20(5)%20(1).webp?alt=media&token=45c54841-8854-498c-8bc6-5ccee71b22e6",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBharatRam-project%2FIMG20230218191056.webp?alt=media&token=75cbb3b3-b5a0-4182-94bd-ba15789d58ae",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBharatRam-project%2FIMG20230218191107.webp?alt=media&token=1f883b67-1ee9-4d4a-8b27-ae38584c9cbc",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBharatRam-project%2FIMG_20230219_201900.webp?alt=media&token=d5c394c4-4ba9-4438-8603-4df5d8489324",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBharatRam-project%2FIMG_20230219_201916.webp?alt=media&token=4f3903a2-2116-4025-a37a-392c018a230f",
    youtube: "",
    title: "BharatRam Global School",
    cardtext:
      "It Became a beautiful place of creativity and art form representing various art forms performed in music and dance room .Art room was transford into creative environment where students can showcase their innovative thoughts. Play room was playful and a visually delight retreat for students which enrich the educational experience.",
    info: (
      <div>
        <p>
          It became a beautiful place of creativity and art form representing
          various art forms performed in music and dance room .Art room was
          transformed into creative environment where students can showcase
          their innovative thoughts.
        </p>{" "}
        <br />{" "}
        <p>
          Play room was playful and a visually delight retreat for students
          which enrich the educational experience.
        </p>
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 4,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBrahmaKumaris-project%2FIMG-20231229-WA0128.webp?alt=media&token=8087927d-593b-47e7-a2dd-568adcdd0f72",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBrahmaKumaris-project%2FIMG-20231229-WA0097.webp?alt=media&token=49d5aa22-7812-470d-a658-d3d173a669c8",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBrahmaKumaris-project%2FIMG-20231229-WA0098.webp?alt=media&token=525bb61d-dca3-41d0-8c54-8497c96b183d",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBrahmaKumaris-project%2FIMG-20231229-WA0104.webp?alt=media&token=54ec83bc-bc04-422d-ad1c-bf4d8510237a",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FBrahmaKumaris-project%2FIMG-20231229-WA0102.webp?alt=media&token=83e575bb-5bee-4684-864b-8b3b93d7e513",
    youtube: "",
    title: "Brahma Kumari",
    cardtext:
      "Initiated in September 2021, bloomed into peaceful, calm fear for women's meditation in kurukshetra Haryana providing space for spiritual growth and inner reflection. It also has culture paintings in the environment and contributing to harmony.",
    info: (
      <div>
        Initiated in September 2021, bloomed into peaceful, calm atmosphere for
        women&#39;s meditation in kurukshetra Haryana providing space for
        spiritual growth and inner reflection. It also has culture paintings in
        the environment and contributing to harmony.
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 5,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FMartiniCafe-project%2FIMG_20230423_224504.webp?alt=media&token=42dd5a36-5a1f-4d4c-8b47-cab08b2804af",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FMartiniCafe-project%2FIMG20230422142609.webp?alt=media&token=81c48d6f-96ab-4658-9d7d-21722fdb196a",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FMartiniCafe-project%2FIMG_20230423_224504.webp?alt=media&token=42dd5a36-5a1f-4d4c-8b47-cab08b2804af",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FMartiniCafe-project%2FIMG_20230422_210832.webp?alt=media&token=a665e18f-7080-4ba5-9cde-add441fe0963",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2FMartiniCafe-project%2FIMG_20230422_210723.webp?alt=media&token=e0c765bb-1c08-487f-a5d5-c2303a8e1bff",
    youtube: "",
    title: "Martini Cafe",
    cardtext:
      "Atmosphere of the cafe was elevated by performing modern arts would showcased elegance. Spot is also dedicated here as a selfie point enhancing the visual pleasures and experience of customers. This artwork was performed during the year 2023.",
    info: (
      <div>
        Atmosphere of the cafe was elevated by performing modern arts would
        showcased elegance. Spot is also dedicated here as a selfie point
        enhancing the visual pleasures and experience of customers. This artwork
        was performed during the year 2023.
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 6,
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fadwait-project%2FIMG-20231229-WA0112.webp?alt=media&token=e852a113-a1e3-4e81-a36d-2a0074e19791",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fadwait-project%2FIMG-20231229-WA0114.webp?alt=media&token=46096cd8-751a-48bf-91c9-dcefa05c2b88",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fadwait-project%2FIMG-20231229-WA0125.webp?alt=media&token=54bf2afb-05d7-45dd-af1e-79e0e67b9fd0",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fadwait-project%2FIMG-20231229-WA0124.webp?alt=media&token=6255a0d4-66ad-4e7b-8359-fecf411f73fb",
    img5: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/media%2Fprojects%20Pics%2Fadwait-project%2FIMG-20231229-WA0118.webp?alt=media&token=85a27a74-9d5b-4f2e-ae79-f4b9628dcd7d",
    youtube: "",
    title: "Adwait",
    cardtext:
      "Advait established in December 2018, in Allahabad serving as a mediator which connects art forms representing beautiful meanings. Here, MahaKumbh wall art was adopted the art form that was used was Patchitra, which left a artistic mark on Naini railway station.",
    info: (
      <div>
        <p>
          Adwaiit established in December 2018, in Allahabad serving as a
          mediator which connects art forms representing beautiful meanings.
          Here, MahaKumbh wall art was adopted the art form that was used was
          Patchitra, which left a artistic mark on Naini railway station.
        </p>
        <br />
        <p>
          Other work like Nagwaski temple situated beside the river in Allahabad
          was enhanced with adorning the pillar beauty works. Making a visually
          fascinating environment.
        </p>
        <br />
        <p>
          Represents commitment to infusing various art works into public spaces
          and creating appealing environment.
        </p>
      </div>
    ),
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
];

export const teamData = [
  {
    id: 1,
    name: "Anurag",
    title: "Base King",
    img: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/team%2F1.webp?alt=media&token=75c9c202-459e-4a7b-94ba-303b288972a8",
  },

  {
    id: 2,
    name: "Irfan ali",
    title: "Chotu master",
    img: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/team%2F3.webp?alt=media&token=ce0dfb90-a496-4d10-aeb9-ef3bc03ce3c8",
  },

  {
    id: 3,
    name: "Aakash",
    title: "Base King",
    img: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/team%2F5.webp?alt=media&token=8d426d0f-fcad-48e8-a68d-e6c9bdd16903",
  },

  {
    id: 4,
    name: "Ali",
    title: "Stencil master",
    img: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/team%2FWhatsApp%20Image%202026-07-17%20at%2011.33.18.jpeg?alt=media&token=eed9928e-c1d5-4f60-b450-ae5e872e1753",
  },

    {
    id: 4,
    name: "Kishan kumar",
    title: "All Rounder",
    img: "https://firebasestorage.googleapis.com/v0/b/renukiran-a6410.appspot.com/o/team%2FWhatsApp%20Image%202026-07-17%20at%2011.18.07.jpeg?alt=media&token=acb13cae-41b2-48ea-9682-2ccd51607a4c",
  },

  {
    id: 5,
    name: "Naveen",
    title: "Realist King",
    img: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/team%2F2.webp?alt=media&token=639f0e93-3856-44df-ba83-c7b89918316c",
  },

  {
    id: 6,
    name: "Sanjay Baghel",
    title: "Stroke master",
    img: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/team%2FUntitled%20design%20(2).webp?alt=media&token=5c7260b6-760f-413b-86a6-8e5ce1fc3d17",
  },

  {
    id: 7,
    name: "Sourav",
    title: "All rounder",
    img: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/team%2F7.webp?alt=media&token=f850e618-3571-4479-a2fd-3f3a560fdeb3",
  },
];

export const graphicDesgignData = [
  {
    id: 1,
    title: "Graphic design",
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/graphic%20design%20work%2F2.webp?alt=media&token=c85c2836-f42d-4d72-9724-3f44042dde78",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/graphic%20design%20work%2F1.webp?alt=media&token=60671c7e-41a4-4ed1-a78c-32e27e43f79a",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/graphic%20design%20work%2F3.webp?alt=media&token=a31c0229-e274-4839-8372-e1d277c7e95b",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/graphic%20design%20work%2F4.webp?alt=media&token=e4e91c21-7577-48a4-b50b-dcbffde70f87",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
];

export const sculptureData = [
  {
    id: 1,
    title: "Sculpture 1",
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FPXL_20230606_070035357.MP.webp?alt=media&token=32d252d5-60c1-4a19-b750-d57907b3b29f",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FPXL_20230602_111810068.MP.webp?alt=media&token=79348c4d-8c96-4a6f-917f-350b29dc9a5e",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FPXL_20230602_111827158.MP.webp?alt=media&token=44311bdc-40b6-4ef0-b84e-9a9c95a4e47e",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FPXL_20230603_052757062.webp?alt=media&token=3d673540-69cd-4afd-814c-04e28ba33ec5",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 2,
    title: "Sculpture 2",
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FPXL_20221205_111102902.MP.webp?alt=media&token=14e18d2c-4f44-4c29-818a-6aaf37de49b6",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FPXL_20221205_111055863.webp?alt=media&token=375d6af7-660e-43bc-8818-897f243cf6a0",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FPXL_20221205_111016649.webp?alt=media&token=a2a53818-935f-44c4-bd27-01767ba336ba",
    img4: "",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 3,
    title: "Sculpture 3",
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FIMG_20190511_013809.webp?alt=media&token=35444106-9634-4749-8bec-41bb061995d9",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FIMG_20190414_191424.webp?alt=media&token=7e4865eb-77af-4545-b7db-c541b32b1ba5",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FIMG_20190409_001909.webp?alt=media&token=aa7ca823-e2a0-4916-a4cd-98bf9b390e1d",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FIMG_20190409_001858.webp?alt=media&token=511a420a-1a05-4bfd-b741-deeb149dded3",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 4,
    title: "Sculpture 4",
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FIMG-20190403-WA0028.webp?alt=media&token=79b312bb-ab03-4823-8c52-b5dfca342799",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FIMG_20190402_171919.webp?alt=media&token=b31eecab-84dd-4346-b69b-e666fd6b314a",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FIMG_20190331_205803.webp?alt=media&token=003571fc-4f2e-4d63-a974-86b35b7bd100",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/sculpture%2FIMG_20190331_205753.webp?alt=media&token=ebc359a7-2e66-4b1f-9619-b11c4241630e",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
];

export const paintingData = [
  {
    id: 1,
    title: "Painting 1",
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/Painting%2FWhatsApp%20Image%202024-01-30%20at%2015.06.10%20(1).webp?alt=media&token=b38b6909-7696-48ca-98ff-920c9e8ac21d",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/Painting%2FWhatsApp%20Image%202024-01-30%20at%2015.06.10.webp?alt=media&token=8545124a-ef16-4ca7-abfe-1fbe4e62214a",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/Painting%2FPicsart_23-11-18_12-11-38-436.webp?alt=media&token=0fac4eaa-30a4-4adb-b5d3-263d968616bf",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/Painting%2FPicsart_23-06-21_15-51-01-285.webp?alt=media&token=1d85e8ce-2a1b-4800-b301-8f9ee59514fd",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },

  {
    id: 2,
    title: "Painting 2",
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/Painting%2FWhatsApp%20Image%202024-01-30%20at%2015.06.12%20(2).webp?alt=media&token=1e32ee2e-a890-4f54-a8a1-c2c8eb97f0ea",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/Painting%2FWhatsApp%20Image%202024-01-30%20at%2015.06.12.webp?alt=media&token=cf1b1652-406d-4eaa-8dab-f932e6b7a7d1",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/Painting%2FWhatsApp%20Image%202024-01-30%20at%2015.06.12%20(1).webp?alt=media&token=beb3911c-dda4-4196-af23-337290432ee5",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/Painting%2FWhatsApp%20Image%202024-01-30%20at%2015.06.11.webp?alt=media&token=fb0efdc6-bb92-42c3-8edc-2fb141df0fc3",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
];

export const portraitData = [
  {
    id: 1,
    title: "Portrait 1",
    img1: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/potrait%2FPicsart_23-06-21_15-04-17-441.webp?alt=media&token=f04da768-4ff8-4a07-9726-77862e1553e6",
    img2: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/potrait%2FIMG-20231118-WA0015.webp?alt=media&token=a7090ce5-1af9-46ae-ae46-32d27d3cd64e",
    img3: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/potrait%2FIMG-20211128-WA0001~2.webp?alt=media&token=cabe25e7-dda7-43ce-b61d-fa508ecdf4ff",
    img4: "https://firebasestorage.googleapis.com/v0/b/taba-5c32a.appspot.com/o/potrait%2FPicsart_23-06-21_02-51-57-074.webp?alt=media&token=1813bd6d-f207-4b2d-9d21-fd8b5f211121",
    ButtonText: (
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        Name="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    ),
  },
];
